import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import ImageIcon from '@mui/icons-material/Image';
import InputAdornment from '@mui/material/InputAdornment';
import FileManagement from '../components/FileManagement';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const childRefFM = React.useRef();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  
  const [displayChk, setDisplayChk] = React.useState(true);
  const [sequence, setSequence] = React.useState(1);
  const [topicName, setTopicName] = React.useState("");
  const [image, setImage] = React.useState("");

  ///const [topicName, setTopicName] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    if(open && props.dataObj && props.dataObj.id){	
      if(props.dataObj.display===1){
        setDisplayChk(true);
      }else{
        setDisplayChk(false);
      }
      setSequence(props.dataObj.sequence);
      setTopicName(props.dataObj.title);
      setImage(props.dataObj.image);

    }else{
      setDisplayChk(true);
      setSequence(1);
      setTopicName("");
    }
	}, [props.dataObj,open]);

	function saveData(){    
    
    if(!sequence){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter sequence");			
      return false;
    } 
    if(!topicName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter keyword name");			
      return false;
    }  

    
		if(sequence>0){ 
      setSaveLoading(true);

			let axiosHeader = {
				headers: {
          'Content-Type': 'multipart/mixed',
            'device': 'web',
            'uid': userObj.loginId,
            'fullName': userObj.fullName,
            'token': userObj.token,
        }
			}; 
      ///alert('asdf '+JSON.stringify(props.dataObj));
			const data = new FormData();
      if(props.dataObj && props.dataObj.id){
        data.append('id', props.dataObj.id);
      }
      data.append('parentId', props.dataObj.parentId);
      data.append('oldSequence', props.dataObj.sequence);      
      data.append('sequence', sequence);
      data.append('keywordName', topicName);
      data.append('image', image);
      if(displayChk===true){
        data.append('display', 1);
      }else{
        data.append('display', 0);
      }

      let apiURL='/crm-update-keywords-treeview';
      let myMessage="Keyword has been updated.";
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");          
					setAlertMessage(myMessage);
          // if(response.data.obj.list && response.data.obj.list.length>0){
          //   ///document.write(JSON.stringify(response.data.obj.list));
          //   props.tempTreeview(response.data.obj.list);	
          // }
          setOpen(false);
					setShowAlert(true);         
					return false;

        }else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("It could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}
  
  const handleDisplayChk = (event) => {
    setDisplayChk(event.target.checked);
  };

  const selectFile = () => {
		childRefFM.current.handleClickOpen();
	}

  function getFileData(obj){
    setImage(obj.fileName);
  }

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.dataObj!=null?<>Edit</>:<>New</>} </h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Keyword Name</td>
                            <td style={{textAlign:'center'}} >
                                <TextField onChange={event => setTopicName(event.target.value)} value={topicName} placeholder={'Keyword Name'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Sequence</td>
                            <td style={{textAlign:'center'}} >
                                <TextField onChange={event => setSequence(event.target.value)} value={sequence} placeholder={'Sequence'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Image</td>
                            <td>
                              {(image && image.length>0)?<img src={props.dataObj.virtualUrl+'/'+image} height={30} />:null}
                            <TextField 
                                onChange={event => setImage(event.target.value)}
                                value={image} 
                                placeholder={'Course Image'}
                                variant="standard"
                                fullWidth
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <ImageIcon style={{cursor:'pointer'}} onClick={()=>{selectFile()}} />
                                    </InputAdornment>
                                  ),
                                  }}
                              />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Display</td>
                            <td>
                              <Checkbox
                                checked={displayChk}
                                onChange={handleDisplayChk}
                                inputProps={{ 'aria-label': 'controlled' }}
                              />
                            </td>                            
                        </tr>
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          {saveLoading?
                          <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Saving</LoadingButton>
					    	          :
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</Button>
                          }
                      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <FileManagement setFileData={getFileData} ref={childRefFM} />

    </>
  );

});

export default CustomizedDialogs;